import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDoubleArrowRight = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#CAD5E3",
		fillRule: "nonzero",
		d: "M.22 1.28 4.94 6 .22 10.72a.75.75 0 0 0 1.06 1.06l5.25-5.25a.75.75 0 0 0 0-1.06L1.28.22A.75.75 0 0 0 .22 1.28m6.375 1.125L10.189 6 6.595 9.595a.75.75 0 0 0 1.06 1.06L11.78 6.53a.75.75 0 0 0 0-1.06L7.655 1.345a.75.75 0 0 0-1.06 1.06"
	})
});
export default SvgDoubleArrowRight;
